import { Directive, inject, OnInit } from '@angular/core';
import { FilterService } from '../filter.service';
import { MainFilterOption } from '../models';

@Directive()
export abstract class BaseFilterComponent implements OnInit {
  protected abstract filterOptions: () => MainFilterOption[];
  protected filterService = inject(FilterService);

  protected localFilterOptions = this.filterService.localFilterOptions;
  protected paginationStates = this.filterService.paginationStates;
  protected hasMoreOptions = this.filterService.hasMoreOptions;
  protected searchControls = this.filterService.searchControls;

  ngOnInit() {
    this.filterService.initialize(this.filterOptions());
  }

  public loadMoreOptions(option: MainFilterOption): void {
    this.filterService.loadMoreOptions(option);
  }

  protected isLoadingMore(key: string): boolean {
    return this.paginationStates()[key]?.isLoading || false;
  }

  protected loadInitialData(option: MainFilterOption): void {
    const paginationState = this.paginationStates()[option.key];
    if (option.optionsObservable && paginationState && paginationState.allOptions.length === 0 && !paginationState.isLoading) {
      const searchControl = this.searchControls()[option.key];
      if (searchControl) {
        searchControl.setValue('', { emitEvent: true });
      }
    }
  }
}
